/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { JsonCompat } from '../../compat/JsonCompat';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { OasOperation } from '../../openapi/models/OasOperation';
import { OasPathItem } from '../../openapi/models/OasPathItem';

/**
 * A command used to delete all servers from a document.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllOperationsCommand extends AbstractCommand {
    static ALL_METHODS : string[]; public static ALL_METHODS_$LI$() : string[] { if(DeleteAllOperationsCommand.ALL_METHODS == null) DeleteAllOperationsCommand.ALL_METHODS = ["get", "put", "post", "delete", "head", "patch", "options", "trace"]; return DeleteAllOperationsCommand.ALL_METHODS; };

    public _parentPath : NodePath;

    public _oldOperations : Array<any>;

    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>OasPathItem) || parent === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldOperations===undefined) this._oldOperations = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldOperations===undefined) this._oldOperations = null;
            (() => {
                this._parentPath = Library.createNodePath(parent);
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldOperations===undefined) this._oldOperations = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldOperations===undefined) this._oldOperations = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllOperationsCommand] Executing.");
        this._oldOperations = <any>([]);
        let parent : OasPathItem = <OasPathItem>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        for(let index213=0; index213 < DeleteAllOperationsCommand.ALL_METHODS_$LI$().length; index213++) {
            let method = DeleteAllOperationsCommand.ALL_METHODS_$LI$()[index213];
            {
                let oldOp : OasOperation = <OasOperation>NodeCompat.getProperty(parent, method);
                if(!this.isNullOrUndefined(oldOp)) {
                    let oldOpData : any = JsonCompat.objectNode();
                    JsonCompat.setPropertyString(oldOpData, "_method", method);
                    JsonCompat.setProperty(oldOpData, "_operation", Library.writeNode(oldOp));
                    /* add */(this._oldOperations.push(oldOpData)>0);
                    NodeCompat.setProperty(parent, method, null);
                }
            }
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllOperationsCommand] Reverting.");
        if(this._oldOperations == null || /* size */(<number>this._oldOperations.length) === 0) {
            return;
        }
        let parent : OasPathItem = <OasPathItem>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        for(let index214=0; index214 < this._oldOperations.length; index214++) {
            let oldOperationData = this._oldOperations[index214];
            {
                let method : string = JsonCompat.getPropertyString(oldOperationData, "_method");
                let operation : OasOperation = parent.createOperation(method);
                Library.readNode(JsonCompat.getProperty(oldOperationData, "_operation"), operation);
                NodeCompat.setProperty(parent, method, operation);
            }
        }
    }
}
DeleteAllOperationsCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllOperationsCommand";
DeleteAllOperationsCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

